module.exports = __webpack_public_path__ + "img/Strength.4e621a02.png";